var config = {
  // baseURL: "https://jc08o9dt14.execute-api.us-east-2.amazonaws.com/test/",
  baseURL: "https://cs248vz1i3.execute-api.us-east-2.amazonaws.com/v1/",
  id_tokenAdmin:
    "CognitoIdentityServiceProvider.3dqtf4c0g43c047gkrsadgutp6.admin.idToken",
  id_tokenRegulator:
    "CognitoIdentityServiceProvider.3dqtf4c0g43c047gkrsadgutp6.regulator.idToken",
  adminFileProcess: "admin/shareplus/file-info",
  channelList: "admin/shareplus/channel",
  removeHash: "admin/shareplus/reset?reset_hash=",
  memberUpload: "admin/shareplus/upload-membership?channel=",
  needUpload: "admin/shareplus/upload-need?channel=",
  accumulatorUpload: "admin/shareplus/upload-accumulator?channel=",
  transactionUpload: "admin/shareplus/upload-transaction?channel=",
  reset: "admin/shareplus/reset",
  promote: "admin/shareplus/promote",
  agentRule: "admin/shareplus/agent-commision",
  deleteAgentRule: "admin/shareplus/agent-commision?rule_id=",
  regulatorPayableShareWalletBalance: "payable/sharewallet-balance?",
  regulatorPayableOpsDashbard:
    "payable/get-quicksight-dashboard-url?dashboard_id=",
  regulatorPayableAdminReserveWeekly:
    "payable/admin-reserve?report-type=weekly",

  regulatorPayableAdminReserveMonthly:
    "payable/admin-reserve?report-type=monthly",

  regulatorPayableYTDReport: "payable/ytd-report?",
  regulatorPayableYTDTransReport:
    "regulator-report?report-type=transaction_expansion&required_date=",

  regulatorPayableYTDReportMonthly:
    "payable/ytd-report?report-type=monthly_brief&channel=",

  regulatorPayableYTDReportWeekly:
    "payable/ytd-report?report-type=weekly&channel=",

  regulatorPayableTransactionRule: "admin/shareplus/channel-rule?channel=",
  regulatorPayableAggregateReportByChannel: "payable/aggregate-bucket",
  regulatorPayableShareplusSummary: "payable/shareplus-meta-info",

  regulatorMonthlyNeedsAggregate: "needs-and-contribution/monthly-needs",
  regulatorNeeds: "needs-and-contribution?report-type=needs_report&",
  regulatorNeedExport: "/needs-and-contribution?report-type=needs_list",
  regulatorNeedsRequests: "needs-and-contribution/need-requests",
  regulatorNeedsContributionDetails:
    "regulator-report?report-type=contribution_details&claim_id=",

  regulatorHouseHoldReport:
    "subcriber/household-report?report-type=search_household&",
  regulatorHouseHoldQuery:
    "subcriber/household-report?report-type=query_household&",
  regulatorHouseHoldQueryTransaction: "subcriber/transactions?empi=",
  regulatorHouseHoldQueryNeeds: "subcriber/needs?empi=",
  regulatorHouseHoldQueryContribution: "subcriber/contribution?empi=",

  regulatorHouseHoldMonthlyReport:
    "subcriber/household-report?report-type=household_monthly_report",
  regulatorHouseHoldWeeklyReport:
    "subcriber/household-report?report-type=household_weekly_report_detail",
  regulatorMemberMonthlyReport:
    "subcriber/household-report?report-type=member_monthly_report",
  regulatorMemberWeeklyReport:
    "subcriber/household-report?report-type=member_weekly_report_detail",
  regulatorPastDue: "subcriber/household-past-due?",
  regulatorSaleByPlan: "subcriber/household-report?report-type=sales_by_plan",
  regulatorAgencyCommission: "agency/commission",
  regulatorAgentCommission: "agent/commission",
  regulatorAgenctTransaction: "agent/transactions?agent_id=",
  regulatorAgentSales: "agent/sales?report-type=agent_sales",
  regulatorAgentSalesDetailed:
    "agent/sales?report-type=agent_sales_detail&agent_id=",
  empDetails: "/admin/shareplus/member-info?empi="
};

export default config;